export function Pagination({
  page,
  pageSize,
  total,
  onChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onChange: (p: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  // Build compact page list: 1 ... current-1, current, current+1 ... last
  const pages: (number | "ellipsis")[] = [];
  const push = (n: number) => {
    if (!pages.includes(n)) pages.push(n);
  };
  push(1);
  if (page - 1 > 2) pages.push("ellipsis");
  for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++)
    push(i);
  if (page + 1 < totalPages - 1) pages.push("ellipsis");
  if (totalPages > 1) push(totalPages);

  const btn = "h-9 min-w-[36px] rounded-lg px-3 text-sm font-medium transition-all";
  const active = "bg-primary text-white shadow-md shadow-primary/25";
  const inactive = "border border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50";
  const disabled = "border border-zinc-100 bg-zinc-50 text-zinc-300 cursor-not-allowed";

  return (
    <div className="mt-6 flex flex-col items-center gap-2 sm:flex-row sm:justify-between">
      <p className="text-xs text-zinc-400">
        Showing {start}–{end} of {total}
      </p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onChange(Math.max(1, page - 1))}
          disabled={page === 1}
          className={`${btn} ${page === 1 ? disabled : inactive}`}
        >
          ← Prev
        </button>
        {pages.map((p, i) =>
          p === "ellipsis" ? (
            <span key={`e${i}`} className="px-1 text-zinc-400">
              …
            </span>
          ) : (
            <button
              key={p}
              onClick={() => onChange(p)}
              className={`${btn} ${p === page ? active : inactive}`}
            >
              {p}
            </button>
          ),
        )}
        <button
          onClick={() => onChange(Math.min(totalPages, page + 1))}
          disabled={page === totalPages}
          className={`${btn} ${page === totalPages ? disabled : inactive}`}
        >
          Next →
        </button>
      </div>
    </div>
  );
}
